import { Box, Card, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getUser } from "../../api/users";
import { useWeb3Context } from "../../context/UseWeb3Context";

const CheckoutCard = ({ name, amount, quantity, size, isMintForMe }) => {
  const [user, setUser] = useState();
  const { account } = useWeb3Context();

  useEffect(() => {
    if (account) {
      getUser(account).then((res) => {
        setUser(res);
      });
    }
  }, []);

  return (
    <Card
      sx={{
        padding: "20px",
        background: "#F5F5F5",
      }}
    >
      <Typography variant="h5">{name}</Typography>

      <Typography variant="h6">
        USD&nbsp;<b>{amount}</b>
      </Typography>

      <Box>
        <Typography>
          Quantity : <b>{quantity}</b>
        </Typography>
      </Box>

      {!isMintForMe && (
        <Box>
          <Typography>
            Size : <b>{size}</b>
          </Typography>
        </Box>
      )}

      {!isMintForMe && (
        <Box>
          <Typography>
            Address : {user?.address?.street},{user?.address?.city},
            {user?.address?.state},{user?.address?.country}-{user?.address?.zip}
          </Typography>
        </Box>
      )}
    </Card>
  );
};

export default CheckoutCard;
